import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from "../../../core/shared/shared.module";
import { CustomersListRouting } from "./customers-list.routing";
import { CustomersListComponent } from "./customers-list.component";
import { CustomersRest } from "./../customers.rest";
import { LoginRest } from "../../../login/login.rest";

@NgModule({
  imports: [
    CommonModule,
    CustomersListRouting,
    SharedModule,
  ],
  declarations: [CustomersListComponent],
  exports: [CustomersListComponent],
  providers : [CustomersRest, LoginRest]
})
export class CustomersListModule { }
